/* globals process */
/* globals gtag */
import React, { useCallback, useState, useMemo, useEffect } from "react"
import "./SearchBar.css"

import { useDispatch, useSelector } from "react-redux"
import {
  SetSliderValueMinMax,
  SetUrlPrefix,
  SetImgPrefix,
  SetSliderValue,
  SetSearchWord,
  SetProducts,
  SetFilters,
  SetResultsCount,
  SetMasterCategories,
  SetPages,
  SetAutocompleteCategoriesOptions,
  SetAutocompleteOptions,
  SetIsExpanded,
  SetConfig,
  SetAsyncData,
  SetListingBanner,
  SetPrevProducts,
  SetPage,
  SetSuggestedWords,
  SetActiveFilters,
  SetWordsHistory,
  SetIsSearching,
  SetIsAutocompleteOpen,
  SetIsFromHalfScreen,
  setUrlQuery,
  SetSort,
} from "../../state/actions/index"
import getSymbolFromCurrency from "currency-symbol-map"
import Utils from "../../utils/Utils"
import axios from "axios"
import Cookies from "universal-cookie"
import $ from "jquery"
import { useNavigate, useParams } from "react-router-dom"

const SearchBar = () => {
  const { query, params } = useParams()

  const sorts = useSelector((state) => state.config.sorts)
  const config = useSelector((state) => state.config)
  const advancedCustomization = useSelector(
    (state) => state.advancedCustomization
  )
  const searchWord = useSelector((state) => state.searchWord)
  const autocomplete = useSelector((state) => state.config.autocomplete)
  const priceGroup = useSelector((state) => state.config.priceGroup)
  const categoriesOptions = useSelector(
    (state) => state.autocompleteCategoriesOptions
  )
  const options = useSelector((state) => state.autocompleteOptions)
  const webhook = useSelector((state) => state.config.webhook)
  const filters = useSelector((state) => state.config.filters)
  // const lastUpdate = useSelector(state => state.lastUpdate);
  const baseUrl = useSelector((state) => state.config.baseUrl)
  const card = useSelector((state) => state.config.card)
  const triggers = useSelector((state) => state.config.triggers)
  const shopId = useSelector((state) => state.config.shopId)
  const show = useSelector((state) => state.config.show)
  const display = useSelector((state) => state.config.display)
  const promotions = useSelector(
    (state) => state.config.promotions.autocomplete
  )
  const ga4 = useSelector((state) => state.config.ga4)
  const urlPrefix = useSelector((state) => state.urlPrefix)
  const imgPrefix = useSelector((state) => state.imgPrefix)
  const isMobile = useSelector((state) => state.isMobile)
  const products = useSelector((state) => state.products)
  const prevProducts = useSelector((state) => state.prevProducts)
  const activeFilters = useSelector((state) => state.activeFilters)
  const defaultMasterCategories = useSelector(
    (state) => state.defaultMasterCategories
  )
  const sliderValue = useSelector((state) => state.sliderValue)
  const sliderValueMinMax = useSelector((state) => state.sliderValueMinMax)
  const searchbarPlaceholder = useSelector((state) =>
    state.config.placeholders ? state.config.placeholders.searchbar : ""
  )
  const sort = useSelector((state) => state.sort)
  const seoSettings = useSelector((state) => state.config.seoSettings)
  const urlQuery = useSelector((state) => state.urlQuery)
  const urlFilters = useSelector((state) => state.urlFilters)
  const filtersName = useSelector((state) => state.config.filters)
  const [cancelToken, setCancelToken] = useState(null)
  const [showAutocomplete, setShowAutocomplete] = useState(false)
  const [localSort, setLocalSort] = useState(sort)
  const [usedLocalSort, setUsedLocalSort] = useState(false)
  // const [timestamp, setTimestamp] = useState(0);
  const dispatch = useDispatch()
  const cookies = new Cookies()
  const isAutocompleteActive = useMemo(
    () =>
      (!isMobile && autocomplete.desktop) || (isMobile && autocomplete.mobile),
    [isMobile, autocomplete]
  )
  const reactivePromotions = useMemo(
    () => (isMobile ? promotions.mobile : promotions.desktop),
    [isMobile, promotions]
  )

  // const navigate = useNavigate();
  const [seoActiveValues, setSeoActiveValues] = useState()

  const categoryFilter = useMemo(() => {
    var objectToReturn = {}
    Object.keys(filters).forEach((item) => {
      if (filters[item].isCategory)
        objectToReturn = { name: item, value: filters[item] }
    })
    return objectToReturn
  }, [filters])

  const categoryKey = useMemo(() => {
    const filter = Object.keys(filters).find((key) => filters[key].isCategory)
    return filter || ""
  }, [filters])

  const queryOptions = useSelector((state) => state.config.queryOptions)
  var rows = useMemo(
    () => (isMobile ? queryOptions.rows.mobile : queryOptions.rows.desktop),
    [isMobile, queryOptions]
  )

  var currencySymbol = useMemo(
    () =>
      getSymbolFromCurrency(
        advancedCustomization
          ? advancedCustomization.currencyCode
          : priceGroup.currency
      ),
    [advancedCustomization, priceGroup]
  )

  var minChars = useMemo(
    () =>
      isMobile ? autocomplete.minChars.mobile : autocomplete.minChars.desktop,
    [isMobile, autocomplete]
  )

  const isPromo = useCallback(
    (item) =>
      reactivePromotions.isActive &&
      options.indexOf(item) === options.length - 1,
    [reactivePromotions, options]
  )

  var wordsHistoryResponsive = useMemo(
    () =>
      isMobile ? triggers.wordsHistory.mobile : triggers.wordsHistory.desktop,
    [triggers, isMobile]
  )
  const cookieMaxAge = useMemo(() => {
    switch (wordsHistoryResponsive.timeframe) {
      case "1D":
        return 86400
      case "1W":
        return 604800
      case "1Y":
        return 31536000
      default:
        return 86400
    }
  }, [wordsHistoryResponsive])

  const handleWordsHistory = useCallback(
    (word) => {
      var words =
        cookies.get("ASWordsHistory") !== undefined
          ? cookies.get("ASWordsHistory")
          : []
      var wordsToHandle = [...words]
      if (
        !words.some((item) => item.toLowerCase().includes(word.toLowerCase()))
      ) {
        var check =
          word.trim() === "" ||
          words.some((item, index) => {
            if (word.toLowerCase().includes(item.toLowerCase())) {
              wordsToHandle[index] = word
              return true
            }
            return false
          })
        if (!check) {
          if (wordsToHandle.length >= 4) wordsToHandle.splice(0, 1)
          wordsToHandle.push(word)
        }
        cookies.set("ASWordsHistory", JSON.stringify(wordsToHandle), {
          maxAge: cookieMaxAge,
        })
        dispatch(SetWordsHistory(wordsToHandle))
      }
    },
    [cookies, cookieMaxAge, dispatch]
  )

  const queryString = useMemo(() => {
    const searchParams = new URLSearchParams()
    let seoUrl = ""
    let filterObj = {}
    let additional = new URLSearchParams()
    if (searchWord) {
      searchParams.set("query", encodeURIComponent(searchWord))
    }
    const locationSearch = window.location.href.slice(
      window.location.href.indexOf("query")
    )
    const sortParams = new URLSearchParams(locationSearch)
    console.log(products)
    if (Array.isArray(activeFilters)) {
      activeFilters.forEach((filter) => {
        if (Array.isArray(filter.value)) {
          additional += `&${filter.key}from=${filter.value[0]}`
          additional += `&${filter.key}to=${filter.value[1]}`
          searchParams.append(`${filter.key}from`, filter.value[0])
          searchParams.append(`${filter.key}to`, filter.value[1])
        } else {
          if (seoSettings?.isActive) {
            seoUrl = ""
            let isSeoAttr = false
            for (const attribute in seoSettings?.attributes) {
              if (
                Object.hasOwnProperty.call(seoSettings?.attributes, attribute)
              ) {
                if (attribute === filter.key) {
                  isSeoAttr = true
                  const value = seoSettings?.attributes[attribute]?.find(
                    (attr) =>
                      attr.key?.toLowerCase() === filter.value?.toLowerCase()
                  )?.value
                  filterObj[filter.key] = [
                    ...(filterObj[filter.key] ?? []),
                    !!value ? value : filter.value,
                  ]
                }
              }
            }
            if (!isSeoAttr) {
              additional += `&${filter.key}=${filter.value}`
            }

            const attributes = Object.keys(seoSettings?.attributes)

            if (Object.keys(filterObj).length > 0) {
              for (const [index, attribute] of Object.entries(attributes)) {
                if (!!filterObj[attribute]) {
                  if (
                    (index === 0 &&
                      Object.keys(seoSettings?.attributes).length < 1) ||
                    index === Object.keys(seoSettings?.attributes).length - 1
                  ) {
                    seoUrl += filterObj[attribute].join(".")
                  } else if (
                    index !==
                    Object.keys(seoSettings?.attributes).length - 1
                  ) {
                    seoUrl += filterObj[attribute].join(".").concat("_")
                  }
                } else {
                  seoUrl += "_"
                }
              }
            }
          }
          searchParams.append(filter.key, filter.value)
        }
      })
    }

    const sortParamsString = sortParams?.toString()
    const possibleSort = sortParamsString?.lastIndexOf("&")
    const sortParamSliced = sortParamsString?.slice(possibleSort)
    // if (
    //   possibleSort !== -1 &&
    //   sort?.label === sorts?.[0]?.label &&
    //   !sortParamSliced.includes("availability") &&
    //   searchWord === ""
    // ) {
    //   additional += `&${
    //     sort?.tiebrakers[0]?.key
    //   }=${sort?.tiebrakers[0]?.value?.toLowerCase()}`
    // }

    if (sort) {
      if (sort?.tiebrakers) {
        additional += `&${
          sort?.tiebrakers[0]?.key
        }=${sort?.tiebrakers[0]?.value?.toLowerCase()}`
      } else {
        additional += `&${sort?.key}=${sort?.value?.toLowerCase()}`
      }
    } else if (
      possibleSort !== -1 &&
      (sortParamSliced?.includes("asc") || sortParamSliced?.includes("desc"))
    ) {
      additional += sortParamSliced
    }

    seoUrl = seoUrl.replace("._", "_")
    setSeoActiveValues(filterObj)

    if (seoSettings?.isActive) {
      if (additional.length > 0) {
        const parsedAdditional = new URLSearchParams(additional)
        return seoUrl.concat(
          "/?query=" + encodeURIComponent(searchWord) + "&" + parsedAdditional
        )
      }
      return seoUrl.concat("/?query=" + encodeURIComponent(searchWord))
    }
    return searchParams.toString()
  }, [searchWord, activeFilters, products])

  useEffect(() => {
    const locationSearch = window.location.href.slice(
      window.location.href.indexOf("query")
    )
    const sortParams = new URLSearchParams(locationSearch)
    const sortParamsString = sortParams?.toString()
    const possibleSort = sortParamsString?.lastIndexOf("&")
    if (possibleSort) {
      const sortParamSliced = sortParamsString?.slice(possibleSort)
      const sortKey = sortParamSliced.substring(1, sortParamSliced.indexOf("="))
      const sortValue = sortParamSliced.substring(
        sortParamSliced.indexOf("=") + 1
      )
      setLocalSort(Utils.getSortFromKeyValue(sorts, sortKey, sortValue))
      SetSort(Utils.getSortFromKey(config.sorts, sortKey))
    }
  })

  useEffect(() => {
    if (localStorage.getItem("isSeoUrlActive") === "true") {
      const startIndex = window.location.href.indexOf(
        `${seoSettings?.searchWord}/`
      )
      if (startIndex !== -1 && activeFilters.length === 0 && queryString) {
        window.history.pushState(
          {},
          "Filter",
          `/#/${seoSettings?.searchWord}${queryString}`
        )
      }
      if ((startIndex === -1 || activeFilters.length !== 0) && queryString) {
        if (queryString?.indexOf("/") === 0) {
          window.history.pushState(
            {},
            "Filter",
            `/#/${seoSettings?.searchWord}${queryString}`
          )
        } else {
          window.history.pushState(
            {},
            "Filter",
            `/#/${seoSettings?.searchWord}/${queryString}`
          )
        }
      }
    }
    // else {
    //   if (!!queryString) {
    //     window.history.pushState({}, "Filter", `/search?${queryString}`);
    //   } else {
    //     window.history.pushState({}, "Filter", `/`);
    //   }
    // }
  }, [queryString])

  useEffect(() => {
    if (localStorage.getItem("isSeoUrlActive") === "true") {
      const startIndex = window.location.href.indexOf(
        `/#/${seoSettings?.searchWord}/`
      )
      const locationSearch = window.location.href.slice(
        window.location.href.indexOf("query")
      )
      const urlSearchParams = new URLSearchParams(locationSearch)
      const wordToSearch = urlSearchParams.get("query")
      if (startIndex !== -1 && activeFilters.length === 0 && !!sort) {
        const sliced = window.location.href.slice(
          startIndex + `/#/${seoSettings?.searchWord}/`.length
        )
        const endIndex = sliced.indexOf("?query")
        if (sliced.substring(0, endIndex).length >= 0) {
          const currentFilters = {}
          const urlFilters = []
          let diffSort = {}

          if (
            (localSort.label !== sorts?.[0]?.label ||
              (localSort.key && localSort.key !== sorts?.[0]?.label)) &&
            !usedLocalSort
          ) {
            diffSort = { key: localSort.key, value: localSort.value }
            setUsedLocalSort(true)
          }
          urlSearchParams.forEach((value, key) => {
            if (value === "asc" || value === "desc") {
              //diffSort = { key, value }
              // const sortValue = Utils.getSortFromKey(config.sorts, key)
              // SetSort(Utils.getSortFromKey(config.sorts, key))
              // $(".sort-dropdown").val(sortValue?.label)
            } else if (key !== "query" && key !== "sellingPriceto") {
              if (key === "sellingPricefrom") {
                urlFilters.push({
                  key: "sellingPrice",
                  value: [value, urlSearchParams.get("sellingPriceto")],
                })
              } else {
                urlFilters.push({ key, value })
              }
            }
          })
          let filtersUrl = sliced?.replace("?" + locationSearch, "")

          if (filtersUrl.endsWith("/")) {
            filtersUrl = filtersUrl.slice(0, filtersUrl.length - 1)
          }
          if (filtersUrl.length > 0) {
            filtersUrl.split("_").forEach((family, index) => {
              const values = []
              family.split(".").forEach((filter) => values.push(filter))

              currentFilters[Object.keys(seoSettings.attributes)[index]] =
                values
            })
          }
          if (
            currentFilters.length > 0 ||
            urlFilters.length > 0 ||
            wordToSearch.length > 0
          ) {
            Utils.openLayer(
              config.display,
              config.show.type,
              window.innerWidth <= 768,
              false
            )
          }
          axios
            .get(
              Utils.getFiltersFromURL(
                config.baseUrl,
                currentFilters,
                config.shopId
              )
            )
            .then((res) => {
              const filtersName = Object.keys(res.data.seo)
              const filterToActivate = []
              for (const filter of filtersName) {
                Object.values(res.data.seo[filter]).forEach((value) =>
                  filterToActivate.push({ key: filter, value })
                )
              }
              dispatch(SetActiveFilters([...filterToActivate, ...urlFilters]))
              dispatch(SetSearchWord(wordToSearch))
              handleSearchSeoURL(
                wordToSearch,
                [...filterToActivate, ...urlFilters],
                diffSort
              )
            })
        }
      }
    }
  }, [sort])

  function handleSearchSeoURL(word, parsedFilters, diffSort) {
    var tempActiveFilters = parsedFilters
    dispatch(SetIsSearching(true))
    dispatch(SetAsyncData([]))
    var priceGroup = {}
    priceGroup.id =
      window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
        ? window.AS_ADVANCED_CONFIG.visitorType
        : config.priceGroup.id
    priceGroup.currency =
      window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
        ? window.AS_ADVANCED_CONFIG.currencyCode
        : config.priceGroup.currency
    var localSearchUrl = Utils.getSearchUrl(
      config.baseUrl,
      config.queryOptions,
      priceGroup,
      config.shopId,
      config.jsonFast
    )
    axios
      .get(
        Utils.insertWordInSearchUrl(
          localSearchUrl,
          word,
          tempActiveFilters,
          Object.keys(diffSort).length > 0
            ? Utils.getSortFromKey(config.sorts, diffSort.key)
            : sort,
          1,
          filtersName,
          rows
        )
      )
      .then((res) => {
        var response = res.data
        dispatch(SetIsExpanded({}))
        dispatch(SetPrevProducts(products))
        dispatch(
          SetProducts(
            Utils.refactorUrl(
              response.data,
              response.header.imagePrefix,
              response.header.urlPrefix,
              card.img,
              card.url
            )
          )
        )
        dispatch(SetSuggestedWords(response.suggestions))
        dispatch(SetResultsCount(response.header.results_count))
        dispatch(
          SetSliderValueMinMax(
            Utils.addSliderValue(response, sliderValueMinMax)
          )
        )
        dispatch(SetSliderValue(Utils.addSliderValue(response, sliderValue)))
        dispatch(
          SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
        )
        dispatch(SetPage(1))
        dispatch(SetFilters(response))
        dispatch(SetListingBanner(response.banners[0]))
        dispatch(
          SetMasterCategories(
            response.stats[categoryKey]
              ? Utils.refactorMasterCategories(
                  Object.keys(response.stats[categoryKey])
                )
              : defaultMasterCategories
          )
        )
        dispatch(SetUrlPrefix(response.header.urlPrefix))
        dispatch(SetImgPrefix(response.header.imagePrefix))
        if (config.webhook.key !== "")
          Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
            (value) => dispatch(SetAsyncData(value.asyncData))
          )
        var websiteSearchBar = document.getElementById(
          "accelasearch-bar-container-container"
        )
        const event = new CustomEvent("as-search-event", {
          detail: { searchWord: word, filters: tempActiveFilters, page: 1 },
        })
        websiteSearchBar.dispatchEvent(event)
      })
      .finally(() => dispatch(SetIsSearching(false)))
  }

  const handleChange = useCallback(
    (value) => {
      var wordToUse = value
      if (wordToUse.length >= minChars) handleWordsHistory(wordToUse)
      var priceGroup = {}
      dispatch(SetSearchWord(wordToUse))
      dispatch(SetActiveFilters([]))
      dispatch(setUrlQuery(wordToUse))

      if (show.type !== "" && show.type === "input" && !isMobile) {
        var websiteSearchButton = null
        if (show.id.desktop === "")
          websiteSearchButton = $(
            document.getElementsByName(show.name.desktop)[0]
          )
        else websiteSearchButton = $("#" + show.id.desktop)
        websiteSearchButton.val(wordToUse)
        if (wordToUse.length < minChars) Utils.closeLayer(display, isMobile)
        if (show.id.desktop === "")
          document.getElementsByName(show.name.desktop)[0].focus()
        else document.getElementById(show.id.desktop).focus()
      }
      if (!isAutocompleteActive) {
        // var timestampNow=new Date().getTime();
        // if(timestampNow-timestamp<500 && cancelToken!=null) cancelToken.cancel('nuova query');
        // setTimestamp(timestampNow);
        var tempCancelToken = axios.CancelToken.source()
        setCancelToken(tempCancelToken)
        if (wordToUse.length < minChars && activeFilters.length === 0)
          dispatch(SetMasterCategories(defaultMasterCategories))
        else if (wordToUse.length >= minChars) {
          dispatch(SetIsSearching(true))
          if (prevProducts.length === 0) {
            dispatch(SetProducts([]))
          }
          dispatch(SetAsyncData([]))
          priceGroup.id =
            window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
              ? window.AS_ADVANCED_CONFIG.visitorType
              : config.priceGroup.id
          priceGroup.currency =
            window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
              ? window.AS_ADVANCED_CONFIG.currencyCode
              : config.priceGroup.currency
          var localSearchUrl = Utils.getSearchUrl(
            config.baseUrl,
            config.queryOptions,
            priceGroup,
            config.shopId,
            config.jsonFast
          )
          axios
            .get(
              Utils.insertWordInSearchUrl(
                localSearchUrl,
                wordToUse,
                activeFilters,
                sort,
                1,
                filters,
                rows
              ),
              {
                cancelToken: tempCancelToken.token,
              } /* {signal:tempCancelToken.signal} */
            )
            .then((res) => {
              var response = res.data
              var getLastUpdate = localStorage.getItem("lastUpdate")
              if (
                !response.extraData?.originated_at ||
                getLastUpdate < response.extraData.originated_at
              ) {
                localStorage.setItem(
                  "lastUpdate",
                  response.extraData?.originated_at
                )
                dispatch(SetIsExpanded({}))
                dispatch(
                  SetMasterCategories(
                    response.stats[categoryFilter.name]
                      ? Utils.refactorMasterCategories(
                          Object.keys(response.stats[categoryFilter.name])
                        )
                      : defaultMasterCategories
                  )
                )
                dispatch(SetPrevProducts(products))
                dispatch(
                  SetProducts(
                    Utils.refactorUrl(
                      response.data,
                      response.header.imagePrefix,
                      response.header.urlPrefix,
                      card.img,
                      card.url
                    )
                  )
                )
                dispatch(SetSuggestedWords(response.suggestions))
                dispatch(SetResultsCount(response.header.results_count))
                dispatch(
                  SetPages(
                    parseInt((response.header.results_count - 1) / rows) + 1
                  )
                )
                dispatch(SetPage(1))
                dispatch(
                  SetSliderValue(Utils.addSliderValue(response, sliderValue))
                )
                dispatch(
                  SetSliderValueMinMax(
                    Utils.addSliderValue(response, sliderValueMinMax)
                  )
                )
                dispatch(SetFilters(response))
                dispatch(SetListingBanner(response.banners[0]))
                dispatch(SetUrlPrefix(response.header.urlPrefix))
                dispatch(SetImgPrefix(response.header.imagePrefix))
                if (webhook.key !== "")
                  Utils.getAsyncData(
                    webhook,
                    response.data,
                    priceGroup,
                    new Date().getTime()
                  ).then((value) => {
                    var getLastUpdateWebhook =
                      localStorage.getItem("lastUpdateWebhook")
                    if (getLastUpdateWebhook < value.timestamp) {
                      localStorage.setItem("lastUpdateWebhook", value.timestamp)
                      dispatch(SetAsyncData(value.asyncData))
                    }
                  })
                var websiteSearchBar = document.getElementById(
                  "accelasearch-bar-container-container"
                )
                const event = new CustomEvent("as-search-event", {
                  detail: { searchWord: wordToUse, page: 1 },
                })
                websiteSearchBar.dispatchEvent(event)
              }
            })
            .finally(() => {
              dispatch(SetIsSearching(false))
            })
        }
      } else {
        dispatch(SetIsAutocompleteOpen(true))
        $("body").addClass("autocomplete-open")
        dispatch(SetMasterCategories(defaultMasterCategories))
        if (wordToUse.length >= minChars) {
          dispatch(SetIsSearching(true))
          priceGroup.id =
            window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
              ? window.AS_ADVANCED_CONFIG.visitorType
              : config.priceGroup.id
          priceGroup.currency =
            window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
              ? window.AS_ADVANCED_CONFIG.currencyCode
              : config.priceGroup.currency
          if (prevProducts.length === 0) dispatch(SetProducts([]))
          axios
            .get(
              Utils.getAutocompleteUrl(
                baseUrl,
                autocomplete,
                wordToUse,
                priceGroup,
                shopId
              ) /* ,{cancelToken:tempCancelToken.token} */
            )
            .then((res) => {
              if (display === "half-screen" && !isMobile) {
                var tempWebsiteSearchButton = null
                if (show.id.desktop === "")
                  tempWebsiteSearchButton = $(
                    document.getElementsByName(show.name.desktop)[0]
                  )
                else tempWebsiteSearchButton = $("#" + show.id.desktop)
                if (
                  tempWebsiteSearchButton.position().left <
                  window.innerWidth / 3
                ) {
                  Utils.setLayerPosition(
                    tempWebsiteSearchButton.position().top + 40,
                    tempWebsiteSearchButton.position().left
                  )
                  Utils.setSearchbarPosition(
                    tempWebsiteSearchButton.position().top + 40,
                    tempWebsiteSearchButton.position().left
                  )
                  Utils.setAutocompletePosition(0, 0)
                } else if (
                  tempWebsiteSearchButton.position().left +
                    tempWebsiteSearchButton.width() >
                  (window.innerWidth * 2) / 3
                ) {
                  Utils.setLayerPosition(
                    tempWebsiteSearchButton.position().top + 40,
                    (window.innerWidth -
                      (tempWebsiteSearchButton.position().left +
                        tempWebsiteSearchButton.width())) /
                      2,
                    "right"
                  )
                  Utils.setSearchbarPosition(
                    tempWebsiteSearchButton.position().top + 40,
                    (window.innerWidth -
                      (tempWebsiteSearchButton.position().left +
                        tempWebsiteSearchButton.width())) /
                      2,
                    "right"
                  )
                  Utils.setAutocompletePosition(0, 0, "right")
                } else {
                  Utils.setLayerPosition(
                    tempWebsiteSearchButton.position().top + 40,
                    tempWebsiteSearchButton.position().left -
                      tempWebsiteSearchButton.width() / 2
                  )
                  Utils.setSearchbarPosition(
                    tempWebsiteSearchButton.position().top + 40,
                    tempWebsiteSearchButton.position().left -
                      tempWebsiteSearchButton.width() / 2
                  )
                  Utils.setAutocompletePosition(0, 0)
                }
              }
              setShowAutocomplete(true)
              var categories = Utils.matchCategories(
                Object.keys(res.data.stats).length > 0
                  ? Object.keys(res.data.stats[categoryFilter.name])
                  : [],
                wordToUse
              ).slice(0, 2)
              var responseLimit =
                autocomplete.limit -
                categories.length -
                (reactivePromotions.isActive ? 1 : 0)
              var response = res.data.data.slice(0, responseLimit)
              dispatch(SetAutocompleteCategoriesOptions(categories))
              var promotionToAdd =
                !reactivePromotions.isActive || response.length === 0
                  ? []
                  : [
                      {
                        src: reactivePromotions.img,
                        url: reactivePromotions.url,
                      },
                    ]
              dispatch(
                SetAutocompleteOptions([
                  ...categories,
                  ...response,
                  ...promotionToAdd,
                ])
              )
              if (response.length === 0) {
                dispatch(SetIsAutocompleteOpen(false))
                $("body").removeClass("autocomplete-open")
              }
            })
            .finally(() => {
              setCancelToken(null)
              dispatch(SetIsSearching(false))
              dispatch(SetPrevProducts([]))
              dispatch(SetProducts([]))
            })
        } else {
          dispatch(SetIsAutocompleteOpen(false))
          $("body").removeClass("autocomplete-open")
          dispatch(SetPrevProducts([]))
          dispatch(SetProducts([]))
          dispatch(SetAutocompleteOptions([]))
        }
      }
    },
    [
      dispatch,
      show,
      reactivePromotions,
      defaultMasterCategories,
      categoryFilter,
      activeFilters,
      baseUrl,
      filters,
      card,
      rows,
      prevProducts,
      webhook,
      config,
      isMobile,
      display,
      setShowAutocomplete,
      shopId,
      /* setOptions,setCategoriesOptions, */ minChars /* timestamp, */,
      products,
      sort,
      sliderValue,
      sliderValueMinMax,
      isAutocompleteActive,
      autocomplete,
      /* cancelToken, */ setCancelToken,
      handleWordsHistory,
    ]
  )

  const onSelectOptions = useCallback(
    (evt, fromKeyUp = false) => {
      /* if(!isMobile) */ Utils.riSetSearchbarPosition(isMobile)
      var tempCancelToken = axios.CancelToken.source()
      setCancelToken(tempCancelToken)
      var priceGroup = {}
      var localSearchUrl = ""
      if (display === "half-screen" && !isMobile)
        Utils.setLayerPosition(0, "50%")
      if (
        !fromKeyUp &&
        categoriesOptions.some(
          (item) => item.category.toLowerCase() === evt.toLowerCase()
        )
      ) {
        var valueToUse = ""
        var categoryIndex = 0
        var caregoryOption = ""
        categoriesOptions.some((item) => {
          if (item.category.toLowerCase() === evt.toLowerCase()) {
            caregoryOption = item.fullCategory
          }
          return item.category.toLowerCase() === evt.toLowerCase()
        })
        var categorySplitted = caregoryOption.split("/")
        categoryIndex = categorySplitted.indexOf(evt)
        valueToUse =
          categorySplitted.slice(0, categoryIndex + 1).join("/") +
          (categorySplitted.length - 1 === categoryIndex ? "" : "/*")
        var tempActiveFilter = [{ key: categoryFilter.name, value: valueToUse }]
        dispatch(SetSearchWord(""))
        dispatch(SetIsSearching(true))
        dispatch(SetIsAutocompleteOpen(false))
        if (prevProducts.length === 0) dispatch(SetProducts([]))
        $("body").removeClass("autocomplete-open")
        dispatch(SetAsyncData([]))
        priceGroup.id =
          window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
            ? window.AS_ADVANCED_CONFIG.visitorType
            : config.priceGroup.id
        priceGroup.currency =
          window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
            ? window.AS_ADVANCED_CONFIG.currencyCode
            : config.priceGroup.currency
        localSearchUrl = Utils.getSearchUrl(
          config.baseUrl,
          config.queryOptions,
          priceGroup,
          config.shopId,
          config.jsonFast
        )
        axios
          .get(
            Utils.insertWordInSearchUrl(
              localSearchUrl,
              "",
              tempActiveFilter,
              sort,
              1,
              filters,
              rows
            )
          )
          .then((res) => {
            var response = res.data
            dispatch(SetIsExpanded({}))
            dispatch(SetPrevProducts(products))
            dispatch(SetProducts(response.data))
            dispatch(SetSuggestedWords(response.suggestions))
            dispatch(SetResultsCount(response.header.results_count))
            dispatch(
              SetSliderValueMinMax(
                Utils.addSliderValue(response, sliderValueMinMax)
              )
            )
            dispatch(
              SetSliderValue(Utils.addSliderValue(response, sliderValue))
            )
            dispatch(SetFilters(response))
            dispatch(SetListingBanner(response.banners[0]))
            dispatch(SetActiveFilters(tempActiveFilter))
            dispatch(
              SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
            )
            dispatch(SetPage(1))
            dispatch(
              SetMasterCategories(
                response.stats[categoryFilter.name]
                  ? Utils.refactorMasterCategories(
                      Object.keys(response.stats[categoryFilter.name])
                    )
                  : defaultMasterCategories
              )
            )
            dispatch(SetUrlPrefix(response.header.urlPrefix))
            dispatch(SetImgPrefix(response.header.imagePrefix))
            if (config.webhook.key !== "")
              Utils.getAsyncData(
                config.webhook,
                response.data,
                priceGroup
              ).then((value) => dispatch(SetAsyncData(value.asyncData)))
          })
          .finally(() => dispatch(SetIsSearching(false)))
      } else {
        if (cancelToken != null) cancelToken.cancel("nuova query")
        handleWordsHistory(evt)
        dispatch(SetSearchWord(evt))
        dispatch(SetActiveFilters([]))
        dispatch(SetIsSearching(true))
        dispatch(SetIsAutocompleteOpen(false))
        if (prevProducts.length === 0) dispatch(SetProducts([]))
        $("body").removeClass("autocomplete-open")
        dispatch(SetAsyncData([]))
        priceGroup.id =
          window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
            ? window.AS_ADVANCED_CONFIG.visitorType
            : config.priceGroup.id
        priceGroup.currency =
          window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
            ? window.AS_ADVANCED_CONFIG.currencyCode
            : config.priceGroup.currency
        localSearchUrl = Utils.getSearchUrl(
          config.baseUrl,
          config.queryOptions,
          priceGroup,
          config.shopId,
          config.jsonFast
        )
        axios
          .get(
            Utils.insertWordInSearchUrl(
              localSearchUrl,
              evt,
              activeFilters,
              sort,
              1,
              filters,
              rows
            ),
            { cancelToken: tempCancelToken.token },
            { headers: { Connection: "keep-alive" } }
          )
          .then(async (res) => {
            var response = res.data
            dispatch(SetIsExpanded({}))
            dispatch(
              SetMasterCategories(
                response.stats[categoryFilter.name]
                  ? Utils.refactorMasterCategories(
                      Object.keys(response.stats[categoryFilter.name])
                    )
                  : defaultMasterCategories
              )
            )
            dispatch(SetPrevProducts(products))
            dispatch(
              SetProducts(
                Utils.refactorUrl(
                  response.data,
                  response.header.imagePrefix,
                  response.header.urlPrefix,
                  card.img,
                  card.url
                )
              )
            )
            dispatch(SetSuggestedWords(response.suggestions))
            dispatch(SetResultsCount(response.header.results_count))
            dispatch(
              SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
            )
            dispatch(SetPage(1))
            dispatch(SetListingBanner(response.banners[0]))
            dispatch(
              SetSliderValue(Utils.addSliderValue(response, sliderValue))
            )
            dispatch(
              SetSliderValueMinMax(
                Utils.addSliderValue(response, sliderValueMinMax)
              )
            )
            dispatch(SetFilters(response))
            dispatch(SetUrlPrefix(response.header.urlPrefix))
            dispatch(SetImgPrefix(response.header.imagePrefix))
            if (config.webhook.key !== "")
              Utils.getAsyncData(
                config.webhook,
                response.data,
                priceGroup
              ).then((value) => dispatch(SetAsyncData(value.asyncData)))
          })
          .finally(() => {
            setCancelToken(null)
            dispatch(SetIsSearching(false))
          })
      }
      dispatch(SetAutocompleteOptions([]))
    },
    [
      dispatch,
      categoriesOptions,
      defaultMasterCategories,
      categoryFilter,
      activeFilters,
      sort,
      filters,
      products,
      display,
      isMobile /* setOptions, */,
      rows,
      prevProducts,
      sliderValue,
      sliderValueMinMax,
      config,
      cancelToken,
      card,
      setCancelToken,
      handleWordsHistory,
    ]
  )

  const handleKeyUp = useCallback(
    (evt) => {
      if (evt.keyCode === 13) {
        evt.target.blur()
        onSelectOptions(searchWord, true)
      }
    },
    [onSelectOptions, searchWord]
  )

  const handleKeyUpSearchBar = useCallback(
    (evt) => {
      if (evt.keyCode === 13) {
        if (!isMobile && config.display === "half-screen") {
          Utils.closeLayer("half-screen", isMobile)
          config.display = "full-screen"
          dispatch(SetConfig(config))
          Utils.riSetSearchbarPosition(isMobile)
          Utils.setPosition("accelasearch-searchbar", { left: "50%" })
          dispatch(SetIsFromHalfScreen(true))
          Utils.openLayer("full-screen", "click", isMobile, true)
        } else evt.target.blur()
      }
    },
    [isMobile, config, dispatch]
  )

  const ASActiveFullscreen = useCallback(() => {
    if (!isMobile && config.display === "half-screen") {
      Utils.closeLayer("half-screen", isMobile)
      config.display = "full-screen"
      dispatch(SetConfig(config))
      Utils.riSetSearchbarPosition(isMobile)
      Utils.setPosition("accelasearch-searchbar", { left: "50%" })
      dispatch(SetIsFromHalfScreen(true))
      Utils.openLayer("full-screen", "click", isMobile, true)
    }
  }, [isMobile, config, dispatch])

  const backClick = useCallback(() => {
    if (show.type === "input" && !isMobile)
      Utils.closeLayer(display, window.innerWidth <= 768)
    dispatch(SetAutocompleteCategoriesOptions([]))
    dispatch(SetAutocompleteOptions([]))
    dispatch(SetIsAutocompleteOpen(false))
    dispatch(SetSearchWord(""))
    dispatch(SetActiveFilters([]))
    dispatch(SetPrevProducts([]))
    dispatch(SetProducts([]))
    dispatch(SetResultsCount(0))
    dispatch(SetPage(1))
    dispatch(SetMasterCategories(defaultMasterCategories))
  }, [dispatch, defaultMasterCategories, show, display, isMobile])

  const toProductPage = useCallback(
    (item) => {
      window.location = item[card.url.key].replace("{:url}", urlPrefix)
    },
    [card, urlPrefix]
  )

  const onResize = useCallback(() => {
    if (show.type !== "") {
      if (show.type === "input" && !(window.innerWidth <= 768)) {
        var websiteSearchButton = null
        if (show.id.desktop === "")
          websiteSearchButton = $(
            document.getElementsByName(show.name.desktop)[0]
          )
        else websiteSearchButton = $("#" + show.id.desktop)
        websiteSearchButton.off("keyup paste click")
        websiteSearchButton.on("keyup paste click", (evt) => {
          dispatch(SetSearchWord(evt.target.value))
          if (evt.keyCode === 13) {
            onSelectOptions(evt.target.value, true)
          } else handleChange(evt.target.value)
          if (evt.target.value.length >= minChars) {
            if (display === "windowed" && !(window.innerWidth <= 768))
              websiteSearchButton.addClass("isOpenedLayer")
            Utils.openLayer(display, show.type, window.innerWidth <= 768, false)
          } else {
            if (display === "windowed" && !(window.innerWidth <= 768))
              websiteSearchButton.removeClass("isOpenedLayer")
            Utils.closeLayer(display, window.innerWidth <= 768)
          }
        })
      }
    }
  }, [handleChange, dispatch, show, minChars, display, onSelectOptions])

  const ASSetSearch = useCallback(
    (searchWord, inputFilters = [], page = 1) => {
      var tempActiveFilters = [...inputFilters]
      dispatch(SetSearchWord(searchWord))
      dispatch(SetIsSearching(true))
      dispatch(SetAsyncData([]))
      var priceGroup = {}
      priceGroup.id =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
          ? window.AS_ADVANCED_CONFIG.visitorType
          : config.priceGroup.id
      priceGroup.currency =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
          ? window.AS_ADVANCED_CONFIG.currencyCode
          : config.priceGroup.currency
      var localSearchUrl = Utils.getSearchUrl(
        config.baseUrl,
        config.queryOptions,
        priceGroup,
        config.shopId,
        config.jsonFast
      )
      axios
        .get(
          Utils.insertWordInSearchUrl(
            localSearchUrl,
            searchWord,
            tempActiveFilters,
            sort,
            page,
            filters,
            rows
          )
        )
        .then((res) => {
          var response = res.data
          dispatch(SetIsExpanded({}))
          dispatch(SetPrevProducts(products))
          dispatch(
            SetProducts(
              Utils.refactorUrl(
                response.data,
                response.header.imagePrefix,
                response.header.urlPrefix,
                card.img,
                card.url
              )
            )
          )
          dispatch(SetSuggestedWords(response.suggestions))
          dispatch(SetResultsCount(response.header.results_count))
          dispatch(
            SetSliderValueMinMax(
              Utils.addSliderValue(response, sliderValueMinMax)
            )
          )
          dispatch(SetSliderValue(Utils.addSliderValue(response, sliderValue)))
          dispatch(SetFilters(response))
          dispatch(SetListingBanner(response.banners[0]))
          dispatch(SetActiveFilters(tempActiveFilters))
          dispatch(
            SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
          )
          dispatch(SetPage(page))
          dispatch(
            SetMasterCategories(
              response.stats[categoryKey]
                ? Utils.refactorMasterCategories(
                    Object.keys(response.stats[categoryKey])
                  )
                : defaultMasterCategories
            )
          )
          dispatch(SetUrlPrefix(response.header.urlPrefix))
          dispatch(SetImgPrefix(response.header.imagePrefix))
          if (config.webhook.key !== "")
            Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
              (value) => dispatch(SetAsyncData(value.asyncData))
            )
        })
        .finally(() => dispatch(SetIsSearching(false)))
    },
    [
      dispatch,
      filters,
      defaultMasterCategories,
      rows,
      sort,
      sliderValueMinMax,
      sliderValue,
      config,
      products,
      categoryKey,
      card,
    ]
  )

  useEffect(() => {
    window.addEventListener("resize", () => {
      onResize()
    })
    onResize()
    window.ASSetSearch = ASSetSearch
    window.ASActiveFullscreen = ASActiveFullscreen
    return () => null
  }, [onResize, ASSetSearch, ASActiveFullscreen])

  return (
    <div className="search-bar" id="accelasearch-searchbar">
      <div className="search icon"></div>
      {isAutocompleteActive ? (
        <div>
          <input
            placeholder={searchbarPlaceholder}
            className="input"
            id="as-searchbar"
            value={searchWord}
            autoComplete="off"
            onChange={handleChange}
            onKeyUp={handleKeyUp}
          ></input>
          <div
            id="as-autocomplete"
            className={
              "menu" + (options.length > 0 && showAutocomplete ? " show" : "")
            }
          >
            {options.map((item, index) => {
              return (
                <div
                  onClick={
                    item.category !== undefined
                      ? () =>
                          onSelectOptions(
                            item.category !== undefined ? item.category : item
                          )
                      : isPromo(item)
                      ? null
                      : () => toProductPage(item.data)
                  }
                  className={
                    "item " +
                    autocomplete.highlightMode +
                    (isPromo(item) ? " promo" : "")
                  }
                  key={"item_" + index}
                >
                  {item.category !== undefined ? (
                    <span className="with-category">
                      {" "}
                      <span className="category"> Categories &gt; </span>
                      {item.category
                        .toLowerCase()
                        .split(searchWord.toLowerCase())
                        .map((subItem, subIndex, array) => (
                          <span>
                            <span>{subItem}</span>
                            {subIndex !== array.length - 1 ? (
                              <span> {searchWord}</span>
                            ) : null}
                          </span>
                        ))}
                    </span>
                  ) : isPromo(item) ? (
                    <a
                      href={item.url}
                      onClick={() => {
                        sessionStorage.setItem("isLayerOpen", "false")
                        Utils.sendAnalyticsObject(
                          baseUrl,
                          shopId,
                          "as_click_promotion",
                          {
                            id: 0,
                            type: "autocomplete",
                            device: isMobile ? "mobile" : "desktop",
                          }
                        )
                        if (!!ga4?.isActive) {
                          if (
                            typeof window.dataLayer !== "undefined" &&
                            !!window.dataLayer
                          ) {
                            window.dataLayer.push({
                              event: "as_click_promotion",
                              data: {
                                id: 0,
                                type: "autocomplete",
                                device: isMobile ? "mobile" : "desktop",
                              },
                            })
                          } else if (typeof gtag !== "undefined") {
                            gtag("event", "as_click_promotion", {
                              id: 0,
                              type: "autocomplete",
                              device: isMobile ? "mobile" : "desktop",
                            })
                          }
                        }
                      }}
                    >
                      {" "}
                      <img src={item.src} alt={item.src} />{" "}
                    </a>
                  ) : (
                    <div className="option-item">
                      {autocomplete.item.image ? (
                        <img
                          className="option-img"
                          src={(item.data[card.img.key].length > 0
                            ? item.data[card.img.key][0]
                            : item.data[card.img.key]
                          ).replace("{:image}", imgPrefix)}
                          alt={(item.data[card.img.key].length > 0
                            ? item.data[card.img.key][0]
                            : item.data[card.img.key]
                          ).replace("{:image}", imgPrefix)}
                        />
                      ) : null}
                      <div className="option-title">
                        {item.data[card.title.key]
                          .toLowerCase()
                          .split(searchWord.toLowerCase())
                          .map((subItem, subIndex, array) => (
                            <span key={"autocomplete_sub_item_" + subIndex}>
                              <span>{subItem}</span>
                              {subIndex !== array.length - 1 ? (
                                <span className="highlightned">
                                  {searchWord}
                                </span>
                              ) : null}
                            </span>
                          ))}
                      </div>
                      {autocomplete.item.price ? (
                        <div className="option-price">
                          {" "}
                          {currencySymbol +
                            " " +
                            item.pricing[card.sellingPrice.key]}{" "}
                        </div>
                      ) : null}
                    </div>
                  )}{" "}
                </div>
              )
            })}
          </div>
        </div>
      ) : (
        <input
          placeholder={searchbarPlaceholder}
          value={searchWord}
          onChange={(evt) => handleChange(evt.target.value)}
          onKeyUp={handleKeyUpSearchBar}
          id="as-searchbar"
          autoComplete="off"
        ></input>
      )}
      {searchWord !== "" || activeFilters.length > 0 ? (
        <div className="delete-search" onClick={backClick}></div>
      ) : null}
    </div>
  )
}

export default SearchBar
